import React from 'react'

interface InfoModalProps {
  isOpen: boolean
  title?: string
  message: string
  onClose: () => void
  primaryText?: string
}

export default function InfoModal({ isOpen, title = '안내', message, onClose, primaryText = '확인' }: InfoModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600" aria-label="닫기">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>
        <div className="text-sm text-gray-800 whitespace-pre-wrap leading-relaxed">
          {message}
        </div>
        <div className="mt-5 flex justify-end">
          <button className="px-4 py-2 bg-gray-800 text-white rounded" onClick={onClose}>{primaryText}</button>
        </div>
      </div>
    </div>
  )
}


